
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/itees",
      function () {
        return require("private-next-pages/case-study/itees.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/itees"])
      });
    }
  